import React, { useState, useEffect, useCallback } from 'react';
import { ProjectModal } from '@/components/modals/ProjectModal';
import { useAuth } from '@/contexts/AuthContext';

export function FollowedProjectsModal() {
  const { user } = useAuth();
  const [selectedProjectId, setSelectedProjectId] = useState<string | null>(null);
  const [selectedTab, setSelectedTab] = useState<string | undefined>(undefined);
  const [selectedCommentTab, setSelectedCommentTab] = useState<"internal" | "external" | undefined>(undefined);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Memoize the close handler to prevent unnecessary re-renders
  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedProjectId(null);
    setSelectedTab(undefined);
    setSelectedCommentTab(undefined);
    // SCH-3.5: signal listeners (e.g., BackfillPreviewModal) that the project
    // overlay is closed so they can restore their own UI.
    window.dispatchEvent(new CustomEvent('projectModalClosed'));
  }, []);

  // Listen for custom events from FollowedProjects component and notification clicks
  useEffect(() => {
    const handleOpenModal = (event: CustomEvent) => {
      const { projectId, tab, commentTab } = event.detail;
      setSelectedProjectId(projectId);
      setSelectedTab(tab);
      setSelectedCommentTab(commentTab);
      setIsModalOpen(true);
    };

    const handleCloseModalEvent = () => {
      setIsModalOpen(false);
      setSelectedProjectId(null);
    };

    window.addEventListener('openProjectModal', handleOpenModal as EventListener);
    window.addEventListener('closeProjectModal', handleCloseModalEvent as EventListener);

    return () => {
      window.removeEventListener('openProjectModal', handleOpenModal as EventListener);
      window.removeEventListener('closeProjectModal', handleCloseModalEvent as EventListener);
    };
  }, []);

  return (
    <>
      {selectedProjectId && (
        <ProjectModal
          projectId={selectedProjectId}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          defaultTab={selectedTab}
          defaultCommentTab={selectedCommentTab}
        />
      )}
    </>
  );
} 